var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "local-stories-container" }, [
    _c("div", { staticClass: "local-stories-filters" }, [
      _c("div", { staticClass: "local-stories-filters-inner" }, [
        _c("h3", [_vm._v("FIND LOCAL STORIES")]),
        _vm._v(" "),
        _c("form", [
          _c("div", { staticClass: "text-field keyword-search" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filters.search_term,
                  expression: "filters.search_term"
                }
              ],
              attrs: { type: "text", placeholder: "KEYWORD SEARCH" },
              domProps: { value: _vm.filters.search_term },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.filters, "search_term", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-field" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filters.sort_by,
                    expression: "filters.sort_by"
                  }
                ],
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.filters,
                      "sort_by",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "most recent" } }, [
                  _vm._v("Most Recent")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "most viewed" } }, [
                  _vm._v("Most Popular")
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "by distance" } }, [
                  _vm._v("By Distance")
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-controls" }, [
          _c(
            "a",
            {
              staticClass: "submit-search",
              on: {
                click: function($event) {
                  return _vm.getPosts()
                }
              }
            },
            [_vm._v("SEARCH")]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "local-stories-content" }, [
      _c("div", { staticClass: "search-results" }, [
        _vm.ui.storyCount
          ? _c("div", { staticClass: "search-details" }, [
              _c("div", { staticClass: "search-details-left" }, [
                _c("span", { staticClass: "search-count" }, [
                  _vm._v(_vm._s(_vm.ui.storyCount) + " RESULTS")
                ]),
                _vm.filters.search_term
                  ? _c("span", [
                      _vm._v(" | " + _vm._s(_vm.filters.search_term))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "search-details-right" }, [
                _vm.filtersActive
                  ? _c(
                      "a",
                      {
                        staticClass: "clear-search",
                        on: {
                          click: function($event) {
                            return _vm.clearSearch()
                          }
                        }
                      },
                      [
                        _vm._v("CLEAR SEARCH "),
                        _c("i", { staticClass: "mu-i-cross mu" })
                      ]
                    )
                  : _vm._e()
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "local-stories-loop" },
          _vm._l(_vm.latestResults, function(story) {
            return _c("div", { staticClass: "local-story-block" }, [
              _c(
                "a",
                {
                  staticClass: "local-story-image",
                  attrs: { href: "#/post/" + _vm.urlTitle(story) }
                },
                [
                  _c("img", {
                    attrs: {
                      src: "https://api.everwondr.com" + story.source,
                      alt: story.title
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "local-story-body" }, [
                _c("h5", { staticClass: "location" }, [_vm._v("KINSTON, NC")]),
                _vm._v(" "),
                _c("div", { staticClass: "local-story-body-inner" }, [
                  _c(
                    "a",
                    {
                      staticClass: "story-title",
                      attrs: { href: "#/post/" + _vm.urlTitle(story) }
                    },
                    [_c("h3", { domProps: { innerHTML: _vm._s(story.title) } })]
                  ),
                  _vm._v(" "),
                  _c("p", { domProps: { innerHTML: _vm._s(story.summary) } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "author" }, [
                    _vm._v("POSTED: "),
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          story.first_name + " " + story.last_name
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "date" }, [
                    _vm._v(
                      _vm._s(
                        _vm.printDate(
                          story.posted,
                          "yyyy-MM-dd HH:mm:ss",
                          "MMM d, yyyy"
                        )
                      )
                    )
                  ])
                ])
              ])
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "local-stories-sidebar" }, [
        _c(
          "div",
          { staticClass: "sticky-sidebar" },
          [
            _c("div", { staticClass: "sidebar--header" }, [
              _vm._v("\n          " + _vm._s(_vm.sidebarTitle) + "\n        ")
            ]),
            _vm._v(" "),
            _vm._l(_vm.byViews(_vm.posts.latest), function(story) {
              return _vm.posts.latest.length &&
                _vm.sidebarSettings.feed_type != "manual"
                ? _c(
                    "a",
                    {
                      staticClass: "sidebar--item",
                      attrs: { href: "#/post/" + _vm.urlTitle(story) }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "balance-text",
                              rawName: "v-balance-text.children",
                              modifiers: { children: true }
                            }
                          ],
                          staticClass: "sidebar--title"
                        },
                        [
                          _c("div", {
                            domProps: { innerHTML: _vm._s(story.title) }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "sidebar--date" }, [
                        _vm._v(
                          "POSTED " +
                            _vm._s(
                              _vm.printDate(
                                story.posted,
                                "yyyy-MM-dd HH:mm:ss",
                                "MMMM d, yyyy"
                              )
                            )
                        )
                      ])
                    ]
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _vm._l(_vm.posts.trending, function(story) {
              return _vm.posts.trending.length &&
                _vm.sidebarSettings.feed_type == "manual"
                ? _c(
                    "a",
                    {
                      staticClass: "sidebar--item",
                      attrs: { href: "#/post/" + _vm.urlTitle(story) }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "balance-text",
                              rawName: "v-balance-text.children",
                              modifiers: { children: true }
                            }
                          ],
                          staticClass: "sidebar--title"
                        },
                        [
                          _c("div", {
                            domProps: { innerHTML: _vm._s(story.title) }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "sidebar--date" }, [
                        _vm._v(
                          "POSTED " +
                            _vm._s(
                              _vm.printDate(
                                story.posted,
                                "yyyy-MM-dd HH:mm:ss",
                                "MMMM d, yyyy"
                              )
                            )
                        )
                      ])
                    ]
                  )
                : _vm._e()
            })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "local-stories-load-more" }, [
      _vm.latestResults.length < _vm.posts.latest.length
        ? _c(
            "a",
            {
              on: {
                click: function($event) {
                  return _vm.loadMore()
                }
              }
            },
            [_vm._v("LOAD MORE RESULTS")]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/LocalStories.vue?vue&type=template&id=2aeb0906&
// module id = 429
// module chunks = 0